import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { PageBasedComponent } from '@app/pages/page.based.component';
import { Observable, filter, map, of } from 'rxjs';
import { LoadingSpinnerComponent } from '@shared/components/loading-spinner/loading-spinner.component';
import { environment } from '@env/environment';


@Component({
  selector: 'app-iframe-report',
  standalone: true,
  imports: [
    CommonModule,
    LoadingSpinnerComponent,
  ],
  templateUrl: './iframe-report.component.html',
  styleUrl: './iframe-report.component.css'
})
export class IframeReportComponent extends PageBasedComponent implements OnChanges {
  @Input() reportSheetId: string = "";
  @Input() reportName: string = "";  

  constructor(    
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
  ) {
    super();
    this.isProfileMeLoadComplete$ = this.profileMe$.pipe(map(profileMe => profileMe ? true : false));
  }
  
  isProfileMeLoadComplete$: Observable<boolean> = of(false);
  country = '';
  terminalname = '';
  businesstype = '';
  subregionname = '';
  terminalid = '';      
  urlPartOne = `${environment.qlik.domain}single/?appid=${environment.qlik.appid}&sheet=`;
  urlPartTwo = '&theme=horizon&opt=ctxmenu,currsel';
  urlQuery = '';
  urlToUse = '';
  loadLink = environment.qlik.domain;
  blankLink = "about:blank";
  portraitLink = `${environment.qlik.domain}single/?appid=${environment.qlik.appid}&sheet=d9ae7f43-82da-4b2e-b856-a792880ca0bf&theme=horizon&opt=ctxmenu,currsel`;
  safeSrc: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.portraitLink);
  
  
  ngOnChanges(changes: SimpleChanges) {        
    if (changes.variable && changes.variable.currentValue) {
      console.log(changes.variable.currentValue);
    }        
    console.log(`iframe component, on init`);        
    console.log(`report sheet id = ${this.reportSheetId}`);
    this.profileMe$
      .pipe(filter(profileMe => profileMe !== null))
      .subscribe(profileMe => {        
        console.log('%j', profileMe);
        console.log(`reportSheetId = ${this.reportSheetId}`);        
        this.urlQuery = '';
        this.country = profileMe.country;
        console.log(`${this.country}`);
        this.urlQuery = `&select=country,${this.country}`;
        if(profileMe.businessTypes !== null){
          this.businesstype = profileMe.businessTypes.join();
          console.log(`${this.businesstype}`);
          this.urlQuery = this.urlQuery + `&select=businesstype,${this.businesstype}`;
        }
        else{
          console.log(`profile me, businesstype is null`);
        }
        if(profileMe.subRegions.length === 0){
          console.log(`profile me, profileMe.subRegions = []`);
        }
        else{
          if( this.reportName.startsWith('country-level-overview') ){
          }
          else{
            this.subregionname = profileMe.subRegions[0].subRegionName;
            console.log(`${this.subregionname}`);
            this.urlQuery = this.urlQuery + `&select=subregionname,${this.subregionname}`;
          }          
        }  
        if(profileMe.terminals.length === 0){
          console.log(`profile me, profileMe.terminals = []`);
        }
        else{
          if( this.reportName.startsWith('country-level-overview') || this.reportName.startsWith('subregion-level-report') ){
          }
          else{
            this.terminalid = profileMe.terminals.map( t => t.terminalId).join();
            console.log(`${this.terminalid}`);
            this.urlQuery = this.urlQuery + `&select=terminalid,${this.terminalid}`;    
            this.terminalname = profileMe.terminals.map( t => t.terminalName).join();
            console.log(`${this.terminalname}`);
            this.urlQuery = this.urlQuery + `&select=terminalname,${this.terminalname}`;
          }          
        }
        console.log(`${this.urlQuery}`);
        this.urlToUse = this.urlPartOne + this.reportSheetId + this.urlQuery + this.urlPartTwo;        
        this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlToUse);
        if(this.reportSheetId === ''){
          this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.portraitLink);
        }                        
    });
  }   

  override ngOnInit(): void {
    super.ngOnInit();        
  }

  override ngAfterViewInit(): void {
    super.ngAfterViewInit();    
  }    
}
